import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private messageService: MessageService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes('/api/logout')) {
            return next.handle(request);
        }

        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].indexOf(err.status) !== -1) {
                const errorMessage = err?.error?.errors?.[0] || err?.error?.message || err?.message || 'Unauthorized access';
                // this.showMessage('error', 'Error', err.error.errors[0]);
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                this.authenticationService.logout();
                //location.reload();
            }

            return throwError(() => err);
        }))
    }

    private showMessage(severity: string, summary: string, detail: string): void {
        this.messageService.add({ severity, summary, detail });
    }
}